// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"bem_a bhj_bk bhj_bl bhj_bo","SwipeLeftToClose--animating":"bem_b"};